import React from "react";
import PriceCalculator from "./components/PriceCalculator";
import { JSX } from "react/jsx-runtime";

export default function App(): JSX.Element {
    return (
        <div className="app-root">
            <PriceCalculator />
        </div>
    );
}